import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { CircularProgressbar,buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { MdClose } from 'react-icons/md';
import Chart from "react-apexcharts";
import "./Cards.css";
import { solenoidData } from "../../Data/Data";
import fetchDataFromApi from "../../api/IotmateRestApi"


// Expanded Card
function ExpandedCard({ param, setExpanded }) {
  const [timeData, setTimeData] = useState([]);
  const [flowDataMap, setFlowDataMap] = useState([]);

  const { omsId } = useParams();

  useEffect(() => {
    const fetchData = async () => {
      try {
        //console.log("OMS Solenoid flow update table",omsId);

        const queryUrl = `time_series/flow/${omsId.slice(4)}/${
          param.solenoidId
        }`;
        const fetchedData = await fetchDataFromApi(queryUrl);
        const timedata1 = fetchedData.map((item) => item.updated_at);
        const flowData1 = fetchedData.map((item) => item.flow_count);
        console.log(`OMS Solenoid flow update timedata  ${timedata1}  flowdata ${flowData1}`);
        const flowDataMap = 
           [
            {
              name: "Flow",
              data: flowData1,
            },
          ];
        
        setTimeData(timedata1);
        setFlowDataMap(flowDataMap);

        //console.log("OMS Details solenoid flow fetched Data", fetchedData);
      } catch (error) {
        //console.log("OMS Solenoid Details update table error",error);
      } finally {
      }
    };

    fetchData();
    //console.log("OMS Details solenoid status datas", data)

    const interval = setInterval(fetchData, 10000); // Fetch data every 5 seconds

    return () => clearInterval(interval); // Cleanup function to clear interval
  }, [omsId,param.solenoidId]);

  const data = {
    options: {
      chart: {
        type: "area",
        height: "auto",
      },

      dropShadow: {
        enabled: false,
        enabledOnSeries: undefined,
        top: 0,
        left: 0,
        blur: 3,
        color: "#000",
        opacity: 0.35,
      },

      fill: {
        colors: ["#fff"],
        type: "gradient",
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
        colors: ["white"],
      },
      tooltip: {
        x: {
          format: "dd/MM/yy HH:mm",
        },
      },
      grid: {
        show: true,
      },
      xaxis: {
        type: "datetime",
        categories: timeData,
      },
    },
  };
  //console.log("OMS Details solenoid flow fetched Data", flowDataMap,timeData);

  return (
    <div
      className="ExpandedCard"
      style={{
        background: param.color.backGround,
        boxShadow: param.color.boxShadow,
      }}
    >
      <div style={{ alignSelf: "flex-end", cursor: "pointer", color: "white" }}>
        <MdClose onClick={setExpanded} />
      </div>
      <span>{param.title}</span>
      <div className="chartContainer">
        <Chart options={data.options} series={flowDataMap} type="area" />
      </div>
      <span>Last 24 hours</span>
    </div>
  );
}

// Compact Card
function SolenoidCompactCard({ param, setExpanded }) {
  const Png = param.png;
  return (
    <div
      className="CompactCard"
      style={{
        background: param.color.backGround,
        boxShadow: param.color.boxShadow,
      }}
      onClick={setExpanded}
    >
      <div className="radialBar">
        <CircularProgressbar value={param.barValue} text={`${param.value}`} 
        background={true}
        styles={buildStyles({ backgroundColor: param.value==="On"? '#8fce00':'#FF9999',
      })}
        />
        <span>{param.value}</span>
      </div>
      <div className="detail  flex flex-row">
        <Png size={20} />
        <span>{param.title}</span>
        <span> {param.lastUpdate}</span>
      </div>
    </div>
  );
}

const SolenoidCard = (props) => {
  const [expanded, setExpanded] = useState(false);
    return (
      expanded ? (
        <ExpandedCard
          param={props}
          setExpanded={() => setExpanded(false)}
        />
      ) : (
        <SolenoidCompactCard
          param={props}
          setExpanded={() => setExpanded(true)}
        />
      )
  );
};

const SolenoidCards = ({data}) => {
  //const [data, setData] = useState([]);
  let status, updateTime;

   return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-5  space-x-2 space-y-2">
      {solenoidData.map((card, id) => {
        status = "Off";
        const series = [
          {
            name: "GSM",
            data: [31, 40, 28, 51, 42, 109, 100],
          },
        ];
        if (data[id]) {
          status = data[id].status ? "On" : "Off";
          updateTime = data[id].updated_at;
        }
        return (
          <div className="h-30" key={id}>
            <SolenoidCard
              title={"Solenoid " + (id + 1)}
              color={card.color}
              solenoidId={id + 1}
              value={status}
              png={card.png}
              lastUpdate={updateTime} //{card.lastUpdate}
              series={series}
            />
          </div>
        );
      })}
    </div>
  );
};

export default SolenoidCards;
